import "core-js/modules/es.error.cause.js";
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { ref, reactive, onMounted } from "vue";
import { ElMessage } from "element-plus";
export default {
  __name: 'index',
  props: {
    captchaId: {
      type: String,
      default: "a9ea395ef961dd6661a023b52bd11867"
    },
    product: {
      type: String,
      default: "bind"
    }
  },
  emits: ["success", "error", "ready"],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    let captchaObj = null;
    const captchaConfig = reactive({
      config: {
        captchaId: props.captchaId,
        product: props.product
      },
      handler: captchaHandler
    });
    function captchaHandler(obj) {
      captchaObj = obj;
      // 将 captchaObj 挂载到全局，方便外部调用
      window.captchaObj = obj;
      obj.appendTo("#captcha").onReady(function () {
        console.log("captcha ready");
        emit("ready");
      }).onNextReady(function () {
        console.log("captcha nextReady");
      }).onBoxShow(function () {
        console.log("captcha boxShow");
      }).onError(function (e) {
        console.log("captcha error:", e);
        ElMessage.error("验证失败");
        emit("error", e);
      }).onSuccess(function (res) {
        console.log("captcha success", res);
        // 获取验证结果信息
        const result = obj.getValidate();
        console.log("验证结果:", result);
        if (result) {
          // 验证成功，将结果传递给父组件
          emit("success", result);
        } else {
          ElMessage.error("获取验证信息失败");
          emit("error", new Error("获取验证信息失败"));
        }
      });
    }

    // 显示验证码
    const showCaptcha = () => {
      if (captchaObj) {
        captchaObj.showCaptcha();
      } else {
        ElMessage.error("验证码未初始化");
      }
    };

    // 重置验证码
    const resetCaptcha = () => {
      if (captchaObj) {
        captchaObj.reset();
      }
    };

    // 暴露方法给父组件
    __expose({
      showCaptcha,
      resetCaptcha
    });
    onMounted(() => {
      console.log("captchaConfig", captchaConfig);
      // 初始化验证码
      if (window.initAlicom4) {
        console.log("initAlicom4", window.initAlicom4);
        window.initAlicom4(captchaConfig.config, captchaConfig.handler);
      }
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        id: "captcha",
        class: _normalizeClass(__props.product === 'bind' ? 'hideHeight' : '')
      }, null, 2);
    };
  }
};